/**
 * Progress bar — default blue. Optional `color` prop for a limited
 * palette. Static class strings only (no dynamic Tailwind construction
 * like `bg-${color}-500` — Tailwind's JIT purger cannot see those and
 * would drop the class from the build).
 */

// Full class strings so Tailwind's purge scanner picks them up.
const FILL_CLASS = {
  blue: 'bg-blue-500',
  purple: 'bg-purple-500',
};

export default function ProgressBar({
  value = 0,
  showLabel = true,
  height = 'h-5',
  className = '',
  color = 'blue',
}) {
  const clamped = Math.min(Math.max(value, 0), 100);
  const fill = FILL_CLASS[color] || FILL_CLASS.blue;

  return (
    <div className={`relative w-full bg-gray-200 rounded-full overflow-hidden ${height} ${className}`}>
      <div
        className={`${fill} ${height} rounded-full transition-all duration-300`}
        style={{ width: `${clamped}%`, minWidth: clamped > 0 ? '4px' : '0' }}
      />
      {showLabel && (
        <span className="absolute inset-0 flex items-center justify-center text-xs font-medium text-foreground">
          {Math.round(clamped)}%
        </span>
      )}
    </div>
  );
}
